define('collection/WaitingListCollection',['require','lib/collection/BaseCollection','model/BookingModel'],function (require) {
	
	var BaseCollection = require('lib/collection/BaseCollection');
	var BookingModel = require('model/BookingModel');
	
	/**
	 * Bookings collection list
	 * 
	 * @class WaitingListCollection
	 */
	return BaseCollection.extend({

		url: '/waiting-list/',
		model: BookingModel
		
	});
	
});
